var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFacebookLogo = function SvgIconFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 12c0 5.52 4.474 9.997 9.993 10h.014C17.527 21.996 22 17.52 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12m10-8a8 8 0 0 0-1 15.938V14.5H9a1 1 0 1 1 0-2h2v-2h1l2.252-3.25h1.498a1 1 0 1 1 0 2h-1.504A1.24 1.24 0 0 0 13 10.496V12.5h2a1 1 0 1 1 0 2h-2v5.438A8.001 8.001 0 0 0 12 4",
    clipRule: "evenodd"
  })));
};
export default SvgIconFacebookLogo;